import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { ProductSale } from "../../../interfaces/tickets/ProductSale";
import { Coupon } from "../../../interfaces/tickets/Coupon";
import {
  NgTicketsConfig,
  NgTicketsConfigService,
} from "../../../services/config.service";

@Component({
  selector: "ng-tickets-success",
  styleUrls: ["./success.component.scss", "../styles/ticket.scss"],
  template: `
    <section class="modal-coupons-success">
      <h2 class="title-section">
        Obrigado por comprar com a {{ config.applicationName || "Allya" }}!
      </h2>
      <p>Confira abaixo os códigos dos cupons:</p>

      <div class="coupons-container">
        <div class="coupon-div" *ngFor="let coupon of coupons">
          <div class="coupon-inner">
            <div class="coupon-header">
              <h2>{{ coupon.value }}</h2>
              <button
                class="coupon-copy"
                (click)="copyToClipboard($event.target, coupon.value)"
              >
                Copiar
              </button>
            </div>
            <p class="ticket-product-name">
              <i class="fa fa-ticket"></i>{{ productSale.ticketProduct.name }}
            </p>
            <p *ngIf="coupon.expirationDate">
              <i class="fa fa-calendar"></i> Valido até:
              {{ coupon.expirationDate | date : "dd/MM/yyyy" }}
            </p>
          </div>
        </div>
      </div>

      <p *ngIf="redirectInfo[groupType].name == 'Cinemark'">
        Os cupons deverão ser usados em
        <a
          target="_blank"
          href="//{{ redirectInfo[groupType].url }}"
          rel="noopener noreferrer"
        >
          {{ redirectInfo[groupType].url }}</a
        >
        ou no aplicativo {{ redirectInfo[groupType].name }}, conforme os passos
        enviados para seu email.
      </p>

      <p *ngIf="redirectInfo[groupType].name == '99'">
        Os cupons deverão ser usados
        <a
          target="_blank"
          href="//{{ redirectInfo[groupType].url }}"
          rel="noopener noreferrer"
        >
          {{ redirectInfo[groupType].url }}</a
        >
        no aplicativo da {{ redirectInfo[groupType].name }}, conforme os passos
        enviados para seu email.
      </p>

      <div
        class="container-button"
        *ngIf="redirectInfo[groupType].name == 'Cinemark'"
      >
        <a
          class="btn btn-pink"
          target="_blank"
          href="//{{ redirectInfo[groupType].url }}"
          rel="noopener noreferrer"
        >
          Ver filmes em {{ redirectInfo[groupType].name }}
          <i class="fa fa-external-link"></i>
        </a>
        <button class="btn-pink-contrast" (click)="nextStep.emit()">
          Comprar mais
        </button>
      </div>

      <div
        class="container-button"
        *ngIf="redirectInfo[groupType].name == '99'"
      >
        <a
          class="btn btn-pink"
          target="_blank"
          href="https://d.99app.com/YULfPDY "
          rel="noopener noreferrer"
        >
          ACESSAR APP {{ redirectInfo[groupType].name }}
          <i class="fa fa-external-link"></i>
        </a>
        <button class="btn-pink-contrast" (click)="nextStep.emit()">
          Comprar mais
        </button>
      </div>
    </section>

    <input #copyArea class="copyArea" type="text" />
  `,
})
export class SuccessComponent {
  @Input() groupType: string;
  @Input() productSale: ProductSale;
  @Input() coupons: Coupon[] = [];
  @Output() nextStep = new EventEmitter();

  @ViewChild("copyArea") copyArea: ElementRef;

  redirectInfo = {
    primepass: { name: "Primepass", url: "primepass.club" },
    cinemark: { name: "Cinemark", url: "cinemark.com.br" },
    99: { name: "99", url: "" },
  };

  constructor(@Inject(NgTicketsConfigService) public config: NgTicketsConfig) {}

  copyToClipboard(event, text) {
    const copyArea = this.copyArea.nativeElement;

    copyArea.value = text;
    copyArea.select();
    copyArea.setSelectionRange(0, 99999); /*For mobile devices*/
    document.execCommand("copy");

    event.classList.add("copied");
    event.innerText = "Copiado";

    setTimeout(() => {
      event.classList.remove("copied");
      event.innerText = "Copiar";
    }, 2000);
  }
}
